import React, { useContext } from 'react'
import './DashboardPage.scss'
import { ArcContext } from 'src/contexts/ArcContext'
import { eqIgnoreCase } from '@arcxmoney/arcx-core'
import { Dashboard } from 'src/components/Dashboard'
import { Title } from 'src/components/Title'

export function DashboardPage() {
  const arcContext = useContext(ArcContext)

  const _synths = arcContext.synths.filter(({ synthetic }) => eqIgnoreCase(synthetic, 'STABLEx'))

  return (
    <div className="dashboard page">
      <div className="dashboard__content">
        <Title
          title="Dashboard"
          description="A quick glance of the ARCx ecosystem"
          className="dashboard__title"
        />
        <Dashboard synths={_synths} />
      </div>
    </div>
  )
}
